import * as React from "react";
const IconTravelLang = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.4863 12C22.4863 17.5228 18.0092 22 12.4863 22M22.4863 12C22.4863 6.47715 18.0092 2 12.4863 2M22.4863 12C22.4863 10.3431 18.0092 9 12.4863 9C6.96348 9 2.48633 10.3431 2.48633 12M22.4863 12C22.4863 13.6569 18.0092 15 12.4863 15C6.96348 15 2.48633 13.6569 2.48633 12M12.4863 22C6.96348 22 2.48633 17.5228 2.48633 12M12.4863 22C14.6955 22 16.4863 17.5228 16.4863 12C16.4863 6.47715 14.6955 2 12.4863 2M12.4863 22C10.2772 22 8.48633 17.5228 8.48633 12C8.48633 6.47715 10.2772 2 12.4863 2M2.48633 12C2.48633 6.47715 6.96348 2 12.4863 2"
      stroke="#1C1C2C"
      strokeWidth={1.5}
    />
  </svg>
);
export default IconTravelLang;
